(function($){
  'use strict';

  if(!$.gnv){
    $.gnv = new Object();
  };

  $.gnv.enableAdditionalService =  function (){
    $('[data-additional-service-addon]').gnv_additionalService();
  };

  $.gnv.additionalService = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.$el.data("gnv.additionalService", base);

    base.init = function(){
      base.options = $.extend({},$.gnv.additionalService.defaultOptions, options);

      if($(window).width()>768)
        base.checkVisibility();
      else
        base.$el.addClass('b-additional_service--visible');

      //Resize
      $(window).on("resize", function(){
        if($(window).width()<769)
          base.$el.addClass('b-additional_service--visible');
      });

      // Scroll
      $(window).on('scroll', function() {
        base.checkVisibility();
      });

    };

    base.checkVisibility = function(){
      if( base.$el.visible() ){
        base.$el.addClass('b-additional_service--visible');
      }
    };

    base.init();
  };

  $.fn.gnv_additionalService = function(options){
    return this.each(function(){
      (new $.gnv.additionalService(this, options));
    });
  };

})(jQuery);
